<template lang="pug">
span 
  portal(to="candidates-account")
    div(class="fill-width")
      select-menu(
        :options="$store.state.cbrUser.items" 
        itemText="username"
        itemValue="ID" 
        :selectedOptions="filters.cbrUser"
        @change="changeFilterMultiple('cbrUser', $event)"
      )
  portal(to="candidates-status")
    div
      select-menu(
        :options="cbrStatusOptions" 
        :selectedOptions="filters.cbrStatus"
        @change="changeFilterMultiple('cbrStatus', $event)"
      )
  portal(to="candidates-product")
    div
      select-menu(
        :getOptions="getProducts" 
        itemText="name"
        itemValue="name" 
        :selectedOptions="filters.examProduct"
        @change="changeFilterMultiple('examProduct', $event)"
      )
  
  portal(to="candidates-lastError")
    text-menu(
      label="Last error" 
      :value="filters.lastError"
      @change="changeFilter('lastError', $event)"
    )
  
  portal(to="candidates-requests")
    v-icon(small @click="toggleQueue").copy-arrow mdi-menu-down
    v-dialog(v-model="queueShowing" :max-width="600")
      v-card
        v-card-title Queue date filters
        v-card-text 
          datepicker(
            v-model="filters.queueExamDateAfter"
            label="Queue date from"
          )
          datepicker(
            v-model="filters.queueExamDateBefore"
            label="Queue date to"
          )
          v-checkbox(
            v-model="filters.queueExamDateStrict"
            label="Queue date strict"
            hide-details
          )
        v-card-actions
          v-spacer
          v-btn(color="error" text @click="toggleQueue") Close
          v-btn(color="success" text @click="submitQueue") Apply

  portal(to="candidates-reserved")
    v-icon(small @click="toggleExamDate").copy-arrow mdi-menu-down
    v-dialog(v-model="examDateShowing" :max-width="600")
      v-card
        v-card-title Exam date filters
        v-card-text
          filter-autocomplete(
            v-model="filters.city"
            :getItems="getExamLocation"
            multiple
            label="Exam Location"
            testName="exam-location"
            clearable
          )
          datepicker(
            v-model="filters.examDateAfter"
            label="Exam date from"
          )
          datepicker(
            v-model="filters.examDateBefore"
            label="Exam date to"
          )
        v-card-actions
          v-spacer
          v-btn(color="error" text @click="toggleExamDate") Close
          v-btn(color="success" text @click="submitExamDate") Apply
</template>

<script>
import {mapActions} from "vuex"
import { CBR_STATUS_OPTIONS } from '../../core/candidates-const'
export default {
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    cbrStatusOptions: CBR_STATUS_OPTIONS,
    dateShowing: false,
    queueShowing: false,
    examDateShowing: false
  }),
  methods: {
    ...mapActions({
      _getProducts: 'crmProductNames/list',
      getExamLocation: 'crmExamLocation/list',
    }),

    getProducts() {
      return this._getProducts({cache: true})
    },

    changeFilterMultiple(field, value) {
      this.$emit('changeMultiple', {field: field, value: value})
    },

    changeFilter(field, value) {
      this.$emit('change', {field: field, value: value})
    },

    toggleDate() {
      this.dateShowing = !this.dateShowing
    },
    
    submitMainDate() {
      this.toggleDate()
      this.$emit('filterChanged')
    },

    toggleQueue() {
      this.queueShowing = !this.queueShowing
    },
    
    submitQueue() {
      this.toggleQueue()
      this.$emit('filterChanged')
    },

    toggleExamDate() {
      this.examDateShowing = !this.examDateShowing
    },
    
    submitExamDate() {
      this.toggleExamDate()
      this.$emit('filterChanged')
    },
  },

  components: {
    selectMenu: () => import('./CandidatesSelectMenu'),
    textMenu: () => import('./CandidateTextMenu.vue'),
    datepicker: () => import('../filters/CandidateDatepickerFilters.vue'),
    filterAutocomplete: () => import('@/components/global/FilterAutocomplete.vue'),

  },
}
</script>